import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingAllBranch() {
  return {
    type: types.FETCH_ALL_BRANCH,
  };
}

function fetchingAllBranchSuccess(payload, count) {
  return {
    type: types.FETCH_ALL_BRANCH_SUCCESS,
    payload,
    count,
  };
}

function fetchingAllBranchFailed() {
  return {
    type: types.FETCH_ALL_BRANCH_FAILED,
  };
}

function fetchingCountry() {
  return {
    type: types.FETCH_COUNTRY,
  };
}

function fetchingCountrySuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingCountryFailed() {
  return {
    type: types.FETCH_COUNTRY_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

function updatingBranch() {
  return {
    type: types.UPDATE_BRANCH,
  };
}

function updatingBranchSuccess(payload) {
  return {
    type: types.UPDATE_BRANCH_SUCCESS,
    payload,
  };
}

function updatingBranchFailed() {
  return {
    type: types.UPDATE_BRANCH_FAILED,
  };
}

function fetchingSingleBranch() {
  return {
    type: types.FETCH_SINGLE_BRANCH,
  };
}

function fetchingSingleBranchSuccess(payload) {
  return {
    type: types.FETCH_SINGLE_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingSingleBranchFailed() {
  return {
    type: types.FETCH_SINGLE_BRANCH_FAILED,
  };
}

function fetchingBranchUser() {
  return {
    type: types.FETCH_BRANCH_USER,
  };
}

function fetchingBranchUserSuccess(payload) {
  return {
    type: types.FETCH_BRANCH_USER_SUCCESS,
    payload,
  };
}

function fetchingBranchUserFailed() {
  return {
    type: types.FETCH_BRANCH_USER_FAILED,
  };
}

function fetchingCountryBranch() {
  return {
    type: types.FETCH_COUNTRY_BRANCH,
  };
}

function fetchingCountryBranchSuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingCountryBranchFailed() {
  return {
    type: types.FETCH_COUNTRY_BRANCH_FAILED,
  };
}

function fetchingStateBranch() {
  return {
    type: types.FETCH_STATE_BRANCH,
  };
}

function fetchingStateBranchSuccess(payload) {
  return {
    type: types.FETCH_STATE_BRANCHSUCCESS,
    payload,
  };
}

function fetchingStateBranchFailed() {
  return {
    type: types.FETCH_STATE_BRANCHFAILED,
  };
}

function fetchingCityBranch() {
  return {
    type: types.FETCH_CITY_BRANCH,
  };
}

function fetchingCityBranchSuccess(payload) {
  return {
    type: types.FETCH_CITY_BRANCHSUCCESS,
    payload,
  };
}

function fetchingCityBranchFailed() {
  return {
    type: types.FETCH_CITY_BRANCHFAILED,
  };
}

function deletingBranch() {
  return {
    type: types.DELETE_BRANCH,
  };
}

function deletingBranchSuccess(payload) {
  return {
    type: types.DELETE_BRANCH_SUCCESS,
    payload,
  };
}

function deletingBranchFailed() {
  return {
    type: types.DELETE_BRANCH_FAILED,
  };
}

function creatingTestimonials() {
  return {
    type: types.CREATE_TESTIMONIAL,
  };
}

function creatingTestimonialsSuccess(payload) {
  return {
    type: types.CREATE_TESTIMONIAL_SUCCESS,
    payload,
  };
}

function creatingTestimonialsFailed() {
  return {
    type: types.CREATE_TESTIMONIAL_FAILED,
  };
}

function fetchingAppliedBranch() {
  return {
    type: types.FETCH_APPLIED_BRANCH,
  };
}

function fetchingAppliedBranchSuccess(payload) {
  return {
    type: types.FETCH_APPLIED_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingAppliedBranchFailed() {
  return {
    type: types.FETCH_APPLIED_BRANCH_FAILED,
  };
}

function creatingAppliedBranch() {
  return {
    type: types.CREATE_APPLIED_BRANCH,
  };
}

function creatingAppliedBranchSuccess(payload) {
  return {
    type: types.CREATE_APPLIED_BRANCH_SUCCESS,
    payload,
  };
}

function creatingAppliedBranchFailed() {
  return {
    type: types.CREATE_APPLIED_BRANCH_FAILED,
  };
}

function updatingAppliedBranch() {
  return {
    type: types.UPDATE_APPLIED_BRANCH,
  };
}

function updatingAppliedBranchSuccess(payload) {
  return {
    type: types.UPDATE_APPLIED_BRANCH_SUCCESS,
    payload,
  };
}

function updatingAppliedBranchFailed() {
  return {
    type: types.UPDATE_APPLIED_BRANCH_FAILED,
  };
}

export function setUpdateButtonClickPlace(payload) {
  return {
    type: types.SET_UPDATE_BUTTON_CLICK_PLACE,
    payload,
  };
}

function changingModerationStatus() {
  return {
    type: types.CHANGE_MODERATION_STATUS,
  };
}

function changingModerationStatusSuccess(payload) {
  return {
    type: types.CHANGE_MODERATION_STATUS_SUCCESS,
    payload,
  };
}

function changingModerationStatusFailed() {
  return {
    type: types.CHANGE_MODERATION_STATUS_FAILED,
  };
}

function fetchingDealerProfileForApplyBranch() {
  return {
    type: types.FETCH_DEALER_PROFILE,
  };
}

function fetchingDealerProfileForApplyBranchSuccess(payload) {
  return {
    type: types.FETCH_DEALER_PROFILE_SUCCESS,
    payload,
  };
}

function fetchingDealerProfileForApplyBranchFailed() {
  return {
    type: types.FETCH_DEALER_PROFILE_FAILED,
  };
}
function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

//****** clearPreviousReducer  ********//

export const clearPreviousReducer = (payload) => async (dispatch) => {
  dispatch(clearingPreviousReducer());
};
//****** Fetching Branch  ********//

export const fetchAllBranch = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllBranch());
  try {
    let response = await api.get(
      `${API.fetchAllBranch}?page=${payload.page}&countryCode=${payload.countryCode}&state=${payload.state}&city=${payload.city}&email=${payload.emailId}&phone=${payload.phone}&branchId=${payload.branchId}&status=${payload.status}&limit=${payload.limit}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingAllBranchSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingAllBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingAllBranchFailed(errorMessage));
  }
};

//****** Fetching Country  ********//

export const fetchCountry = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCountry());
  try {
    let response = await api.get(API.fetchCountry);
    if (response.data.code === 200) {
      dispatch(fetchingCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryFailed(errorMessage));
  }
};

//****** Fetching State  ********//

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(
      `${API.fetchBranchFilterState}?countryCode=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
  }
};

//****** Fetching City  ********//

export const fetchCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchBranchFilterCity}?countryCode=${payload.countryCode}&state=${payload.state}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
  }
};

//****** update Branch  ********//

export const updateBranch = (payload, reqObj) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingBranch());
  try {
    let response = await api.put(API.deleteBranch, payload.formData);
    if (response.data.code === 200) {
      dispatch(updatingBranchSuccess(response.data.data));
      dispatch(fetchAllBranch(reqObj));
      // history.push("/branch/list");
      toast.error(response.data.message);
    } else {
      dispatch(updatingBranchFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingBranchFailed(errorMessage));
  }
};

//****** fetch Single Branch  ********//

export const fetchSingleBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingSingleBranch());
  try {
    let response = await api.get(
      `${API.fetchSingleBranch}?branchId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingSingleBranchSuccess(response.data.data));
    } else if (response.data.code === 409) {
      history.push("/branch/list");
      dispatch(fetchingSingleBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingSingleBranchFailed(errorMessage));
  }
};

//****** fetch  Branch Userh  ********//

export const fetchBranchUser = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingBranchUser());
  try {
    let response = await api.get(API.fetchBranchUser);

    if (response.data.code === 200) {
      dispatch(fetchingBranchUserSuccess(response.data.data));
    } else {
      dispatch(fetchingBranchUserFailed());
    }
  } catch (error) {
    dispatch(fetchingBranchUserFailed(errorMessage));
  }
};

//****** Fetching CountryBranch  ********//

export const fetchCountryBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingCountryBranch());
  try {
    let response = await api.get(API.fetchCountryBranch);
    if (response.data.code === 200) {
      dispatch(fetchingCountryBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingCountryBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryBranchFailed(errorMessage));
  }
};

//****** Fetching State Branch ********//

export const fetchStateBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingStateBranch());
  try {
    let response = await api.get(`${API.fetchStateBranch}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingStateBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingStateBranchFailed(errorMessage));
  }
};

//****** Fetching City Branch ********//

export const fetchCityBranch = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCityBranch());
  try {
    let response = await api.get(
      `${API.fetchCityBranch}?country=${payload.countryCode}&state=${payload.state}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingCityBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingCityBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingCityBranchFailed(errorMessage));
  }
};

//****** Delete Branch ********//

export const deleteBranch = (payload) => async (dispatch, getState, api) => {
  var headers = { branchId: payload };
  dispatch(deletingBranch());
  try {
    let response = await api.delete(API.deleteBranch, { headers: headers });

    if (response.data.code === 200) {
      dispatch(deletingBranchSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(deletingBranchFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(deletingBranchFailed(errorMessage));
  }
};

//****** createTestimonial ********//

export const createTestimonial = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(creatingTestimonials());
  try {
    let response = await api.post(API.createTestimonial, payload.formData);

    if (response.data.code === 200) {
      dispatch(creatingTestimonialsSuccess(response.data.data));
      history.push(`/branch/detail?branchId=${payload.branchId}`);
      toast.error(response.data.message);
    } else {
      dispatch(creatingTestimonialsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingTestimonialsFailed(errorMessage));
  }
};

//****** Fetching Applied Branch  ********//

export const fetchAppliedBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingAppliedBranch());
  try {
    let response = await api.get(
      `${
        API.fetchAllBranch
      }?page=${0}&countryCode=&state=&city=&email=&phone=&branchId=`
    );

    if (payload === "detail") {
      if (response.data.data.length === 0 || response.data.code === 404) {
        history.push("/branch/apply-for-branch-create");
        dispatch(fetchingAppliedBranchFailed());
      } else {
        history.push("/branch/apply-for-branch");
        dispatch(fetchingAppliedBranchSuccess(response.data.data));
      }
    } else {
      if (response.data.code === 200) {
        dispatch(fetchingAppliedBranchSuccess(response.data.data));
      } else {
        dispatch(fetchingAppliedBranchFailed());
      }
    }
  } catch (error) {
    dispatch(fetchingAppliedBranchFailed(errorMessage));
  }
};

//****** CREATE APPLIED Branch  ********//

export const createAppliedBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(creatingAppliedBranch());
  try {
    let response = await api.post(API.createBranch, payload.formData);
    if (response.data.code === 200) {
      dispatch(creatingAppliedBranchSuccess(response.data.data));
      history.push("/");

      toast.error(response.data.message);
    } else {
      dispatch(creatingAppliedBranchFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingAppliedBranchFailed(errorMessage));
  }
};

//****** Update APPLIED Branch  ********//

export const updateAppliedBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingAppliedBranch());
  try {
    let response = await api.put(API.deleteBranch, payload.formData);
    if (response.data.code === 200) {
      dispatch(updatingAppliedBranchSuccess(response.data.data));
      history.push("/branch/update-profile");
      dispatch(fetchSingleBranch(payload.branchId));
      toast.error(response.data.message);
    } else {
      dispatch(updatingAppliedBranchFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingAppliedBranchFailed(errorMessage));
  }
};

//****** change Moderation status  ********//

export const changeModerationStatus = (payload, reqObj) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(changingModerationStatus());
  try {
    let response = await api.post(API.moderationStatus, payload);
    if (response.data.code === 200) {
      dispatch(clearPreviousReducer());
      dispatch(changingModerationStatusSuccess(response.data.data));
      dispatch(fetchAllBranch(reqObj));
      // history.push(`/branch/detail?branchId=${payload.branchId}`);

      dispatch(fetchSingleBranch(payload.branchId));
      toast.error(response.data.message);
    } else {
      dispatch(changingModerationStatusFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(changingModerationStatusFailed(errorMessage));
  }
};

//****** change Moderation status  ********//

export const fetchDealerProfileForApplyBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingDealerProfileForApplyBranch());
  try {
    let response = await api.get(API.fetchDealerProfileForApplyBranch, payload);
    if (response.data.code === 200) {
      dispatch(fetchingDealerProfileForApplyBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingDealerProfileForApplyBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingDealerProfileForApplyBranchFailed(errorMessage));
  }
};
